module.exports = __webpack_public_path__ + "static/media/logo-apollo.70163551.png";